(ns manage.adset.business-logic
  (:require ["src/svg/type/adset_channel/connected_tv.svg$default" :as CtvIcon]
            ["src/svg/type/adset_channel/display.svg$default" :as DisplayIcon]
            ["src/svg/type/adset_channel/meta.svg$default" :as MetaIcon]
            ["src/svg/type/adset_channel/tiktok.svg$default" :as TiktokIcon]
            ["src/svg/type/adset_channel/video.svg$default" :as VideoIcon]
            ["src/svg/type/adset_channel/youtube.svg$default" :as YoutubeIcon]
            [common.util :as util]
            [lemonpi.specs.interface.adset :as adset-spec]))

(def all-country-codes
  (-> adset-spec/country-code-to-country-name keys set))

(def ctv-country-codes
  #{"nl" "us" "ca" "gb" "de" "se" "es" "in" "ch"})

(def workflows
  {:rules {:label "Rule based (includes product store)"
           :icon "rule_rounded"}
   :content-variants {:label "Variant based"
                      :icon "format_list_bulleted_rounded"}
   :ad-variants {:label "Unified"
                 :icon "segment_rounded"}})

(def channels
  {:video {:label "Online Video"
           :icon VideoIcon
           :target-type "vast"
           :workflows (select-keys workflows [:ad-variants :content-variants])
           :countries all-country-codes}
   :display {:label "Display"
             :icon DisplayIcon
             :target-type "dsp"
             :workflows (select-keys workflows [:ad-variants :content-variants :rules])
             :countries all-country-codes}
   :ctv {:label "Connected TV"
         :icon CtvIcon
         :target-type "finecast"
         :workflows (select-keys workflows [:ad-variants :content-variants])
         :countries ctv-country-codes}
   :youtube {:label "Youtube"
             :icon YoutubeIcon
             :target-type "youtube"
             :workflows (select-keys workflows [:ad-variants])
             :countries all-country-codes}
   :meta {:label "Meta"
          :icon MetaIcon
          :target-type "meta"
          :workflows (select-keys workflows [:ad-variants])
          :countries all-country-codes}
   :tiktok {:label "Tiktok"
            :icon TiktokIcon
            :target-type "tiktok"
            :workflows (select-keys workflows [:ad-variants])
            :countries all-country-codes}})

(defn auto-select-workflow
  "Returns the workflow kw if the workflow can be automatically
   selected (i.e. there's only one). Returns an empty string otherwise
   to indicate that someone (likely the user) should choose the workflow."
  [workflow-entries]
  (if (= 1 (count workflow-entries))
    (:value (first workflow-entries))
    ""))

(defn to-adset-spec
  [adset]
  (let [channel (:channel adset)
        target-type (get-in channels [(keyword channel) :target-type])]
    (->> {:channel channel
          :name (:name adset)
          :workflow (:workflow adset)
          :targetType target-type
          :autoApproveAdVariants (= (:production-solution adset) "hogarth")
          :countries (:countries adset)
          :plannedStart (some-> (:planned-dates adset) first (util/format-iso-string "YYYY-MM-DD"))
          :plannedEnd (some-> (:planned-dates adset) second (util/format-iso-string "YYYY-MM-DD"))
          :targetImpressions (:target-impressions adset)}
         (remove #(nil? (second %)))
         (into {}))))

(defn to-adset-spec2
  [adset]
  (let [channel (:channel adset)
        target-type (get-in channels [(keyword channel) :target-type])]
    (-> {:channel channel
         :name (:name adset)
         :workflow (:workflow adset)
         :targetType target-type
         :autoApproveAdVariants (boolean (:autoApproveAdVariants adset))
         :countries (seq (:countries adset))
         :plannedStart (some-> (:plannedDates adset) first (util/format-iso-string "YYYY-MM-DD"))
         :plannedEnd (some-> (:plannedDates adset) second (util/format-iso-string "YYYY-MM-DD"))
         :targetImpressions (:targetImpressions adset)}
        util/filter-nils-map)))
